import OadpEntityButtonCreate from './oadp-entity-button-create';
export default OadpEntityButtonCreate;
